import React, { memo } from 'react';
import { useTranslation } from '@dm/i18n';
import { LogoProps, DEFAULT_IMAGE_SIZE } from '../../Icon/icon';
import LogoIconSvg from '../LogoIconSvg';

const ActiveBeautyBrand = (props: LogoProps) => {
  const [t] = useTranslation();
  const {
    id,
    dmId = 'active-beauty-brand',
    pointerEvents = 'none',
    size = DEFAULT_IMAGE_SIZE,
    ...otherProps
  } = props;

  const viewBox = '0 0 20 8.16';
  const title = t('ds.logo.activeBeautyBrand.title');
  const description = t('ds.logo.activeBeautyBrand.description');

  return (
    <LogoIconSvg
      id={id}
      description={description}
      dmId={dmId}
      pointerEvents={pointerEvents}
      size={size}
      title={title}
      viewBox={viewBox}
      fill="#000000"
      {...otherProps}>
      <path d="m19.292 4.417-.926 1.618-.928-1.618h-.708l1.314 2.211v1.453h.636v-1.445h.003l1.317-2.219z" />
      <path d="m1.6383 7.5081h-1.0283v-1.031h1.0814c.2763 0 .6053.0887.6053.51 0 .3257-.2461.5207-.6584.5207m-1.0283-2.5178h.8686a.7158.7158 0 0 1 .4753.1213.46.46 0 0 1 .1566.3463.4475.4475 0 0 1 -.1552.3505.7124.7124 0 0 1 -.4764.1225h-.8689zm1.6137 1.163a.7932.7932 0 0 0 .4939-.7586.8794.8794 0 0 0 -.3945-.77 1.5123 1.5123 0 0 0 -.9431-.2074h-1.38v3.6643h1.432a1.82 1.82 0 0 0 1.0741-.2173 1.0049 1.0049 0 0 0 .4378-.8659.8576.8576 0 0 0 -.72-.8452" />
      <path d="m13.696 4.99h1.022v3.091h.637v-3.091h1.031v-.573h-2.69z" />
      <path d="m12.5123 6.86c0 .462-.3361.7273-.8517.7273-.5193 0-.8571-.2653-.8571-.7273v-2.4433h-.6367v2.3746a1.2834 1.2834 0 0 0 .3322.9792 1.667 1.667 0 0 0 1.161.3895 1.6588 1.6588 0 0 0 1.1566-.39 1.2829 1.2829 0 0 0 .3319-.9787v-2.3746h-.6367v2.4433z" />
      <path d="m17.366 3.17h-1.883v-1.041h1.645v-.546h-1.645v-.931h1.814v-.573h-2.451v3.665h2.52z" />
      <path d="m10.1665.0793h.6367v3.6643h-.6367z" />
      <path d="m7.93 3.744h.636v-3.092h1.037v-.573h-2.694v.573h1.021z" />
      <path d="m1.6651.8963.477 1.4066h-.9545l.477-1.4063v.0008zm-.3378-.817-1.3273 3.6643h.7025l.2975-.8901 1.3327.0073.2949.8828h.7024l-1.3279-3.6643z" />
      <path d="m13.853.079-.983 2.68-.983-2.68h-.636l1.3 3.665h.639l1.3-3.665z" />
      <path d="m7.7662 6.6166.4645-1.3826.4719 1.3826zm.1533-2.2-1.346 3.6644h.6782l.3083-.9073h1.3368l.3132.9073h.694l-1.3515-3.6643z" />
      <path d="m6.071 7.508h-1.883v-1.042h1.645v-.546h-1.645v-.93h1.814v-.573h-2.451v3.664h2.52z" />
      <path d="m6.0353 2.5738a.8927.8927 0 0 1 -.89.6762c-.6218 0-1.0392-.5475-1.0392-1.3623 0-.7983.4143-1.3145 1.0553-1.3145a.8541.8541 0 0 1 .8822.6942l.013.0576.6257-.06-.0158-.0734a1.4474 1.4474 0 0 0 -1.5052-1.1916 1.7362 1.7362 0 0 0 -1.7185 1.8982 2.1581 2.1581 0 0 0 .3994 1.2942 1.5211 1.5211 0 0 0 1.2926.6305 1.4972 1.4972 0 0 0 1.2821-.631 1.52 1.52 0 0 0 .2616-.5566z" />
    </LogoIconSvg>
  );
};

export default memo(ActiveBeautyBrand);
